import { Box, styled } from "@mui/material";
import { SearchBox } from "@pmag/ui-components";

export const ContainerBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(6, 0),
}));

export const ControlPanel = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(4),
}));

export const ListContainer = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(6),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.core.grey._30}`,
}));

export const SearchBoxPanel = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3),
    backgroundColor: theme.palette.core.grey._20,
    borderBottom: `1px solid ${theme.palette.core.grey._30}`,
}));

export const StyledSearchBox = styled(SearchBox)({
    height: "40px",
});

export const ExplosionGraphicBox = styled(Box)(({ theme }) => ({
    [theme.breakpoints.down("md")]: {
        display: "none",
    },
}));
